<template>
  <div class="daily-work-data">
    <!-- 搜索条件 -->
    <div class="daily-work-data-search">
      <el-form
        ref="dailyWorkFormRef"
        :inline="true"
        :model="dailyWorkForm"
        class="demo-form-inline"
      >
        <el-form-item label="统计时间">
          <el-date-picker
            v-model="dailyWorkForm.statistics_time"
            clearable
            type="daterange"
            unlink-panels
            range-separator="——"
            end-placeholder="结束日期"
            start-placeholder="开始日期"
            size="small"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="人员状态">
          <el-radio-group v-model="dailyWorkForm.user_status">
            <el-radio :label="''">全部</el-radio>
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="0">锁定</el-radio>
            <el-radio :label="2">删除</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" @click="searchBtn">
            查 询<i class="el-icon-search el-icon--right" />
          </el-button>

          <!-- 导出 -->
          <el-button
            type="primary"
            size="small"
            @click="derive"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1840') : false
            "
          >
            导出<i class="el-icon-download el-icon--right" />
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 概括 -->
    <div class="data-info">
      <div class="item">
        <span>日常工作总量：</span>
        <span>{{ statistics_info.total_count }}</span>
      </div>
      <div class="item">
        <span>审核医生认证数：</span>
        <span>{{ statistics_info.auth_doctor_count }}</span>
      </div>
      <div class="item">
        <span>转单数：</span>
        <span>{{ statistics_info.transfer_order_count }}</span>
      </div>
      <div class="item">
        <span>用户拍方数：</span>
        <span>{{ statistics_info.user_picture_count }}</span>
      </div>
      <div class="item">
        <span>用户拍方支付数：</span>
        <span>{{ statistics_info.pay_user_picture_count }}</span>
      </div>
      <div class="item">
        <span>医生拍方数：</span>
        <span>{{ statistics_info.doctor_picture_count }}</span>
      </div>

      <div class="item">
        <span>医生拍方支付数：</span>
        <span>{{ statistics_info.pay_doctor_picture_count }}</span>
      </div>

      <div class="item">
        <span>用户反馈数：</span>
        <span>{{ statistics_info.user_feedback_count }}</span>
      </div>
      <div class="item">
        <span>医生反馈数：</span>
        <span>{{ statistics_info.doctor_feedback_count }}</span>
      </div>
      <div class="item">
        <span>短信发送数：</span>
        <span>{{ statistics_info.sms_count }}</span>
      </div>
      <div class="item">
        <span>分方数：</span>
        <span>{{ statistics_info.separate_order_count }}</span>
      </div>
      <div class="item">
        <span>修改地址数：</span>
        <span>{{ statistics_info.update_address_count }}</span>
      </div>
      <div class="item">
        <span>确认收货数：</span>
        <span>{{ statistics_info.order_receipt_count }}</span>
      </div>
      <div class="item">
        <span>订单备注数：</span>
        <span>{{ statistics_info.order_remark_count }}</span>
      </div>
      <div class="item">
        <span>加急数：</span>
        <span>{{ statistics_info.urgent_count }}</span>
      </div>
      <div class="item">
        <span>开具发票数：</span>
        <span>{{ statistics_info.invoice_count }}</span>
      </div>
      <div class="item">
        <span>待办事项处理数：</span>
        <span>{{ statistics_info.todo_count }}</span>
      </div>

      <div class="item">
        <span>待取药回访数：</span>
        <span>{{ statistics_info.wait_recipe }}</span>
      </div>

      <div class="item">
        <span>待接诊回访数：</span>
        <span>{{ statistics_info.wait_consult_count }}</span>
      </div>

      <div class="item">
        <span>绑定操作数：</span>
        <span>{{ statistics_info.binding_num }}</span>
      </div>
      <div class="item">
        <span>商城订单备注数：</span>
        <span>{{ statistics_info.server_remark_count }}</span>
      </div>
      <div class="item">
        <span>售后退款数：</span>
        <span>{{ statistics_info.after_sales_count }}</span>
      </div>
      <div class="item">
        <span>异常退款数：</span>
        <span>{{ statistics_info.abnormal_count }}</span>
      </div>
    </div>
    <!-- 表格 -->
    <div class="daily-work-data-table">
      <el-table
        v-loading="tableLoading"
        :header-cell-style="{ background: '#F5F5F5' }"
        :data="dailyWorkData"
        style="width: 100%"
        @sort-change="sortChange"
      >
        <el-table-column
          v-for="item in tableHeader"
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
          :width="item.width"
          :fixed="item.fixed"
          :sortable="item.sortable"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="item.prop == 'user_picture_count'">
              {{ scope.row[item.prop] }} /
              {{ scope.row.pay_user_picture_count }}
            </div>

            <div v-else-if="item.prop == 'doctor_picture_count'">
              {{ scope.row[item.prop] }} /
              {{ scope.row.pay_doctor_picture_count }}
            </div>

            <div v-else>
              {{
                JSON.stringify(scope.row[item.prop]) === "null"
                  ? ""
                  : scope.row[item.prop]
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pagination.page"
      :limit.sync="pagination.pageNumber"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination/index.vue";
import dayjs from "dayjs";
import kefu from "@/api/kefu";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      dailyWorkForm: {
        order_key: "",
        order_value: "",
        statistics_time: [],
        user_status: 1,
      },
      total: 100,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      tableHeader: [
        {
          label: "人员",
          prop: "user_name",
          width: "120",
          fixed: "left",
          sortable: false,
        },
        {
          label: "审核医生认证数",
          prop: "auth_doctor_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "转单数",
          prop: "transfer_order_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "用户拍方数/支付数",
          prop: "user_picture_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },

        {
          label: "医生拍方数/支付数",
          prop: "doctor_picture_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "用户反馈数",
          prop: "user_feedback_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "医生反馈数",
          prop: "doctor_feedback_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "短信发送数",
          prop: "sms_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "分方数",
          prop: "separate_order_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "修改地址数",
          prop: "update_address_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "确认收货数",
          prop: "order_receipt_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "订单备注数",
          prop: "order_remark_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "加急数",
          prop: "urgent_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "开具发票数",
          prop: "invoice_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "待办事项处理数",
          prop: "todo_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },

        {
          label: "待取药回访数",
          prop: "wait_recipe",
          width: "auto",
          fixed: false,
          sortable: false,
        },

        {
          label: "待接诊回访数",
          prop: "wait_consult_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },

        {
          label: "绑定操作数",
          prop: "binding_num",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "商城订单备注数",
          prop: "server_remark_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "售后退款数",
          prop: "after_sales_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "异常退款数",
          prop: "abnormal_count",
          width: "auto",
          fixed: false,
          sortable: false,
        },
        {
          label: "总计",
          prop: "total_count",
          width: "auto",
          fixed: "right",
          sortable: "custom",
        },
      ],
      dailyWorkData: [],
      statistics_info: {},
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    statusText(val) {
      switch (val) {
        case 1:
          return "待取药";
        case 2:
          return "待审方";
        case 3:
          return "已通过";
        case 4:
          return "已抓药";
        case 5:
          return "过期未取药";
        case 6:
          return "审方不通过";
        case 7:
          return "医生手动作废";
        case 8:
          return "平台退款";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.dailyWorkForm.statistics_time = [start, end];
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      let params = Object.assign(this.pagination, this.dailyWorkForm);
      params = _.omit(params, ["statistics_time"]);
      let times = this.dailyWorkForm.statistics_time;
      params["statistics_start_time"] = times
        ? dayjs(times[0]).format("YYYY-MM-DD")
        : "";
      params["statistics_end_time"] = times
        ? dayjs(times[1]).format("YYYY-MM-DD")
        : "";

      kefu
        .getDailyWorkData(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.statistics_info = data.statistics_info;
            this.total = data.total;
            this.dailyWorkData = data.list;
            this.tableLoading = false;
          }
        })
        .catch((err) => {
          this.tableLoading = false;
        });
    },
    // 查询
    searchBtn() {
      this.pagination.page = 1;
      this.getList();
    },
    // 导出
    derive() {
      const loading = this.$loading();
      let params = Object.assign(this.pagination, this.dailyWorkForm);
      params = _.omit(params, ["statistics_time"]);
      let times = this.dailyWorkForm.statistics_time;
      params["statistics_start_time"] = times
        ? dayjs(times[0]).format("YYYY-MM-DD")
        : "";
      params["statistics_end_time"] = times
        ? dayjs(times[1]).format("YYYY-MM-DD")
        : "";

      kefu
        .exportDailyWorkData(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    sortChange(e) {
      console.log(e);
      let order = e.order;
      this.dailyWorkForm.order_key = e.prop;

      if (order == "descending") {
        this.dailyWorkForm.order_value = "desc";
      } else if (order == "ascending") {
        this.dailyWorkForm.order_value = "asc";
      } else {
        this.dailyWorkForm.order_key = "";
        this.dailyWorkForm.order_value = "";
      }
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.daily-work-data {
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  .data-info {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;
    .item {
      font-size: 16px;
      font-weight: bold;
      margin: 10px;
    }
  }
  .daily-work-data-search {
    display: flex;
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .daily-work-data-table {
    border: 1px solid #c9cdd6;
    // .el-table {
    // min-height: 476px;
    // }
  }
}
</style>
